// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"30ebd934","574":"71697e02","881":"4ca106bf"}[chunkId] + ".chunk.css";
};